import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Navbar from './Components/Navbar'
import Sidebar from './Components/Sidebar';
import SideDrawer from './Components/SideDrawer';
import Backdrop from './Components/backdrop';
import Routes from './routes'
import { BrowserRouter } from "react-router-dom";
import ScrollToTop from './Components/ScrollToTop'
import { faCoffee, fas, faSearch } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'
import backdrop from './Components/backdrop';
import { getInspectionStatusMaster } from './store/actions/masterActions'
import { connect } from 'react-redux';
import * as ls from "local-storage";
import AuthHandlerInstance from './Classes/AuthHandler'
// import Navigation from './Components/Navigation';

library.add(fab, faCoffee, fas, faSearch)

class App extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      sideDrawerOpen: false,
      opacity: '',
      modal: false,
    }
  }

  drawerToggleClickHandler = async (e) => {
    // document.querySelector("toggle-wrap").classList.toggle("active");
    await this.setState(prevState => {
      return { sideDrawerOpen: !prevState.sideDrawerOpen}
    })
    setTimeout(() => {
      let toggleWrap = document.querySelectorAll(".toggle-wrap")
      document.querySelector('.side-drawer-Toggle').classList.toggle("active")
      for (var i = 0, len = toggleWrap.length; i < len; i++) {
        toggleWrap[i].classList.toggle("active");
      }
    }, 50); 
  }

  modal() {
    this.setState(prevState => {
      return { modal: !prevState.modal }
    })
    //this.setState({ modal: !this.state.modal });
    if (this.state.modal == true) {
      this.setState({ opacity: "" })

    } else {
      this.setState({ opacity: "0.3" })

    }
  }


  componentWillMount() {
    let hash = window.location.hash;
    hash = hash.replace('#', '');
    let param = this.queryStringToJSON(hash);

    if (param && param.code && param.access_token) {
      ls.set("authDetails", {
        authCode: param.code,
        accessToken: param.access_token
      });
      window.location.href = window.location.origin + window.location.pathname;

    }
    AuthHandlerInstance.validateTokenExp();
  }

  queryStringToJSON = (qs) => {

    var pairs = qs.split('&');
    var result = {};
    pairs.forEach(function (p) {
      var pair = p.split('=');
      var key = pair[0];
      var value = decodeURIComponent(pair[1] || '');

      if (result[key]) {
        if (Object.prototype.toString.call(result[key]) === '[object Array]') {
          result[key].push(value);
        } else {
          result[key] = [result[key], value];
        }
      } else {
        result[key] = value;
      }
    });

    return JSON.parse(JSON.stringify(result));
  };

  render() {
    // console.log( AuthHandlerInstance.getPermissions(), AuthHandlerInstance.getUserPayLoad());
    // console.log( "abc", AuthHandlerInstance.getUserPayLoad());
    // let userPayload = AuthHandlerInstance.getUserPayLoad();
    // console.log("user",userPayload.email)

    console.log("user", this.state.sideDrawerOpen)

    return (

      // <div  style={{opacity:this.state.opacity}} >
      <BrowserRouter>
        <div className='box' style={{ opacity: this.state.opacity }} >
          {/* <Navigation drawerClickHandler={this.drawerToggleClickHandler}/> */}
          <Navbar drawerClickHandler={this.drawerToggleClickHandler} />

          {/* {this.state.sideDrawerOpen ? */}
          <SideDrawer drawerClickHandler={this.drawerToggleClickHandler}/>
          {/* : null */}
          {/* } */}
          {/* <Backdrop/> */}
          <main >
            {/* <div  > */}
            <div className='row mt-5 justify-content-center' >
              {/* <div className='col-xs-2 col-sm-2 col-lg-2 d-none d-lg-block ' >
            
               <Sidebar/>
            </div> */}
              <div className='col-xs-12 col-sm-12 col-lg-12 justify-content-center'>
                {/* <div style={{marginLeft:"1.8rem"}} > */}
                <Routes parentModal={this.modal} />
                <ScrollToTop />
              </div>
            </div>
            {/* </div> */}
          </main>
        </div>
      </BrowserRouter>
    )
  }
}

const mapStateToProps = (state) => ({ masterReducer: state.masterReducer })
export default connect(mapStateToProps, { getInspectionStatusMaster })(App)
